class wechatAuth {
	constructor(config) {
		let defaultConfig = {
			appid: '',
			responseType: 'code',
			redirect_uri: '',
			error_uri: '',
			//以snsapi_base为scope的网页授权，就静默授权的，用户无感知；
			//以snsapi_userinfo为scope发起的网页授权，需要用户手动同意;
			scope: 'snsapi_base ',
			getCodeCallback: () => {},
			vue: {}
		}
		this.config = Object.assign(defaultConfig, config)
		//encodeURIComponent进行转化
		this.config.redirectUri = encodeURIComponent(location.href)
	}

	//调取微信获取code接口
	getCode() {
		let authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'
		let authParams = `?appid=${this.config.appid}&redirect_uri=${this.config.redirectUri}&response_type=${this.config.responseType}&scope=${this.config.scope}&state=wechat#wechat_redirect`
		window.location.href = authPageBaseUri + authParams
	}

	next(next) {
		return (to, res) => {
			if (res) {
				to ? next(to) : next()
			} else {
				to && next(to)
			}
		}
	}
	//根据code获取对应的信息
	getCodeCallback(next, code) {
		//调用main.js中的getCodeCallback
		return this.config.getCodeCallback(this.next(next), code)
	}
}

export default wechatAuth
